import React, { useEffect, useRef, useState } from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../label-custom'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { createEducationAPI } from '../../../services/education'
import Autocomplete from '../../custom/autocomplete'
import Error_500 from '../../error/error-500'
import Error_false from '../../error/error-false'
import SwalCustom from '../../../alert/swal-custom'
import UseEducationTypes from '../../../hooks/use-education-type'
import { TXTSUCCESS } from '../../../Constants'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
import updateLocale from 'dayjs/plugin/updateLocale'
import useNumberInput from '../../../helper/input-fix-num'
dayjs.extend(updateLocale)
dayjs.updateLocale('th', {
  weekStart: 0
})

const schema = yup
  .object({
    eduType: yup.object().required('Please, Fill Education Degree'),
    eduQual: yup.string().required('Please, Fill Educational Qualification'),
    eduName: yup.string().required('Please, Fill Institution Name'),
    adYear: yup
      .string()
      .required('Please, Fill Start Year')
      .test(
        'is-gradYear-after-adYear',
        'Pleace, re-check Start Year and Graduated Year again',
        function (value) {
          const gradYear = this.parent.gradYear
          if (!gradYear) return true // Skip validation if gradYear is not set
          return parseInt(value) <= parseInt(gradYear)
        }
      ),
    gradYear: yup.string().required('Please, Fill Graduated Year'),
    eduBg: yup.string().required('Please, Fill Faculty'),
    major: yup.string().required('Please, Fill Major'),
    grade: yup.string().required('Please, Fill Grade')
  })
  .required()

export default function CreateEducationHistory({
  param,
  setIsSave,
  showCreate,
  isSave,
  fnGetWorks,
  setShowCreate
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const educationTypes = UseEducationTypes()
  const [adYear, setAdYear] = useState(null)
  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  useEffect(() => {
    setValue('adYear', `25`)
    setValue('gradYear', `25`)
  }, [setValue, showCreate])

  const onSubmit = async (d) => {
    setIsSave(true)
    const data = {
      eduTypeId: d.eduType.value,
      qualification: d.eduQual,
      eduName: d.eduName,
      adYear: d.adYear,
      gradYear: d.gradYear,
      eduBg: d.eduBg,
      major: d.major,
      grade: d.grade
    }
    const body = { ...param, ...data }
    createWorks(body)
  }

  const createWorks = async (body) => {
    try {
      const data = await createEducationAPI(body)

      if (data?.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          setIsSave(false)
          handleClose()
          fnGetWorks()
          fnReset()
        })
      } else {
        setIsSave(false)
        Error_false(data)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }
  const fnReset = () => {
    setError('eduType', false)
    setError('eduQual', false)
    setError('eduName', false)
    setError('adYear', false)
    setError('gradYear', false)
    setError('eduBg', false)
    setError('major', false)
    setError('grade', false)
  }
  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Education History</label>
        <Col md={12}>
          <LabelCustom text={'Education Degree'} />
          <Controller
            name={'eduType'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Autocomplete
                options={educationTypes}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.eduType?.message && (
            <label className="small text-danger">
              {errors.eduType.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Institution Name'} />
          <Controller
            name={'eduName'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.eduName?.message && (
            <label className="small text-danger">
              {errors.eduName.message}
            </label>
          )}
        </Col>

        <Col xl={6}>
          <LabelCustom text="From (พ.ศ.)" />
          <Controller
            name={'adYear'}
            control={control}
            render={({ field: { value } }) => (
              <>
                {/* <DatepickerFixYearTHCustom
                  value={value}
                  onChange={([date]) => {
                    setValue(
                      'adYear',
                      date ? moment(date).format('YYYY-MM-DD') : ''
                    )
                    setError('adYear', date)
                  }}
                /> */}
                {/* <ConfigProvider locale={locale}>
                  <Space direction="vertical">
                    <DatePicker />
                    <DatePicker picker="week" />
                    <DatePicker picker="month" />
                    <DatePicker picker="quarter" />
                    <DatePicker picker="year" />
                  </Space>
                </ConfigProvider> */}
                <Form.Control
                  value={value}
                  maxLength={4}
                  onKeyDown={handleKeyDownNum}
                  onChange={(e) => {
                    setValue('adYear', e.target.value)
                    setAdYear(e.target.value)
                    setError('adYear', false)
                  }}
                />
                {/* <DatePicker
                  className="form-control"
                  onChange={(date, dateString) => {
                    setValue('adYear', dateString)
                    setAdYear(dateString)
                    setError('adYear', false)
                  }}
                  locale={locale}
                  picker="year"
                  disabledDate={(current) =>
                    current &&
                    disableYearStart &&
                    disableYearStart >= disableYearEnd
                      ? current.year() > parseInt(disableYearEnd)
                      : disableYearStart &&
                        current.year() > parseInt(disableYearStart)
                  }
                /> */}
              </>
            )}
          />
          {errors.adYear?.message && (
            <label className="small text-danger">{errors.adYear.message}</label>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text="To (พ.ศ.)" />
          <Controller
            name={'gradYear'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Form.Control
                value={value}
                maxLength={4}
                onKeyDown={handleKeyDownNum}
                onChange={(e) => {
                  setValue('gradYear', e.target.value)
                  setError('gradYear', false)
                }}
              />
              // <DatePicker
              //   className="form-control"
              //   onChange={(date, dateString) => {
              //     setValue('gradYear', dateString)
              //     setError('gradYear', dateString)
              //     setDisableYearEnd(dateString)
              //   }}
              //   picker="year"
              //   // disabledDate={(current) =>
              //   //   current && adYear && current.year() < parseInt(adYear)
              //   // }
              // />
            )}
          />
          {errors.gradYear?.message && (
            <label className="small text-danger">
              {errors.gradYear.message}
            </label>
          )}
        </Col>

        {/* <Col xl={6}>
          <LabelCustom text="Start" />

          <Controller
            name={'adYear'}
            control={control}
            render={({ field: { value } }) => (
              <DatePicker
                className="form-control"
                onChange={(date, dateString) => {
                  setValue('adYear', dateString)
                  setError('adYear', false)
                }}
                picker="year"
              />
            )}
          />
          {errors.adYear?.message && (
            <label className="small text-danger">{errors.adYear.message}</label>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text="To" />
          <Controller
            name={'gradYear'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <DatePicker
                className="form-control"
                onChange={(date, dateString) => {
                  setValue('gradYear', dateString)
                  setError('gradYear', dateString)
                }}
                picker="year"
              />
            )}
          />
          {errors.gradYear?.message && (
            <label className="small text-danger">
              {errors.gradYear.message}
            </label>
          )}
        </Col> */}

        <Col md={12}>
          <LabelCustom text={'Educational Qualification'} />
          <Controller
            name={'eduQual'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.eduQual?.message && (
            <label className="small text-danger">
              {errors.eduQual.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <LabelCustom text={'Faculty'} />
          <Controller
            name={'eduBg'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.eduBg?.message && (
            <label className="small text-danger">{errors.eduBg.message}</label>
          )}
        </Col>
        <Col xl={12}>
          <LabelCustom text="Major" />
          <Controller
            name={'major'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.major?.message && (
            <label className="small text-danger">{errors.major.message}</label>
          )}
        </Col>

        <Col xl={12}>
          <LabelCustom text="Grade" />
          {/* <Controller
            name={'grade'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              // <Form.Control maxLength={50} value={value} onChange={onChange} />
              <Form.Control 
              type="number" 
              step=".01" 
              inputMode="decimal" 
              maxLength={4} 
              minLength={1}
              value={value} 
              placeholder="0.00"
              onChange={onChange} 
              pattern=".^\d*(\.\d{0,2})?$"
              />
              )}
          /> */}
          <Controller
            name={'grade'}
            control={control}
            render={({ field: { onChange, value = '' } }) => {
              // Define a function to handle input change
              const handleInputChange = (event) => {
                const inputValue = event.target.value
                const formattedValue = inputValue.replace(/[^\d.]/g, '') // Remove any non-digit characters except the decimal point
                onChange(formattedValue)
              }

              return (
                <Form.Control
                  type="text"
                  maxLength={4} // Allow 5 characters including the decimal point
                  value={value}
                  placeholder="0.00"
                  onChange={handleInputChange}
                  pattern="^\d+(\.\d{0,2})?$" // Allow numbers with optional decimal up to 2 places
                />
              )
            }}
          />
          {/* <Controller
            name={'grade'}
            control={control}
            render={({ field: { onChange, value = '' } }) => {
              // Define a function to format the input value with a decimal point
              const handleInputChange = (event) => {
                const inputValue = event.target.value
                const formattedValue = parseFloat(inputValue).toFixed(2) // Format to 2 decimal places
                onChange(formattedValue)
              }

              return (
                <Form.Control
                  type="number"
                  step=".01"
                  inputMode="decimal"
                  maxLength={4}
                  minLength={1}
                  value={value}
                  placeholder="0.00"
                  onChange={handleInputChange}
                />
              )
            }}
          /> */}
          {errors.grade?.message && (
            <label className="small text-danger">{errors.grade.message}</label>
          )}
        </Col>
        <Col xl={12} className="text-center mt-4">
          <Button
            className="px-4 text-primary me-2"
            variant="light"
            type="button"
            size="sm"
            disabled={isSave}
            onClick={handleClose}
          >
            Close
          </Button>
          <Button className="px-4 " size="sm" disabled={isSave} type="submit">
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
